import { enableDrag } from 'core/handlers/DragHandler'
import { enableFade } from 'core/handlers/FadeHandler'
import { signal } from 'services/SignalsService'
import { paytableSettings }from 'settings/paytable'

export default class PaytablePageEntity extends PIXI.Container {
  constructor() {
    super()
    const fade = enableFade(this)
    this.pages = game.models.PaytableModel.getList()
    this.startX = this.x
    this.deviceOrientation = ''
    this.id = this.pages.length
    this.prev = Number.NaN
    game.models.PaytableModel.addID(this.id)

    signal.on('RADIO:menu', (value) => {
      fade(value === 'paytable' && game.models.PaytableModel.getID() === this.id)
      this.interactive = value === 'paytable' && game.models.PaytableModel.getID() === this.id
      this.buttonMode = value === 'paytable' && game.models.PaytableModel.getID() === this.id
    })

    signal.on('PAYTABLE:PAGE', (value) => {
      fade(value === this.id)
      this.interactive = value === this.id
      // this.buttonMode = value === this.id
    })

    signal.on('INIT:PAYTABLE:SLIDER', () => {
      enableDrag(this, { start: this.start.bind(this), move: this.move.bind(this), stop: this.stop.bind(this) })
    })

    signal.on('RESIZE', ({ orientation }) => {
      this.startX = orientation === 'land' ? 0 : -210
      this.deviceOrientation = orientation
    })
  }

  start({ x }) {
    this.prev = x
  }

  move({ x }) {
    this.x += x - this.prev
    if (this.deviceOrientation === 'land') {
      this.x < paytableSettings.leftOffsetLand ? this.x = paytableSettings.leftOffsetLand : {}
      this.x > paytableSettings.rightOffsetLand ? this.x = paytableSettings.rightOffsetLand : {}
    }
    else {
      this.x < paytableSettings.leftOffsetPort ? this.x = paytableSettings.leftOffsetPort : {}
      this.x > paytableSettings.rightOffsetPort ? this.x = paytableSettings.rightOffsetPort : {}
    }

    this.prev = x
  }

  stop() {
    const id = this.x < this.startX ? this.id + 1 :  this.x > this.startX ? this.id - 1  : this.id
    this.x = this.startX
    id < 0 ? game.models.PaytableModel.setID(game.models.PaytableModel.getMaxID()) : id > game.models.PaytableModel.getMaxID() ? game.models.PaytableModel.setID(0) : game.models.PaytableModel.setID(id)
  }
}
